import React, { useState, useEffect } from "react";

import TicketsForm from "../reports/CaseMangement/ticketsform";
import Addfile from "./CaseMangement/Addfile";
import TurnTime from "./CaseMangement/turntime";
import LotSearch from "./lotsearch";
import CasesShipped from "./CaseMangement/CasesShipped";
import CasesCancelled from "./CaseMangement/CasesCanceled";
import IncompleteTask from "./CaseMangement/IncompleteTask";
import CompleteTasks from "./CaseMangement/CompleteTasks";
import CaseTags from "./CaseMangement/CaseTags";
import ProcessImprovement from "./CaseMangement/ProcessImprovement";
import TaggedCases from "./CaseMangement/TaggedCases";
import Shipping from "./CaseMangement/Shipping";
import PatientAppointment from "./CaseMangement/patientAppointment";
import NewCases from "./CaseMangement/NewCases";
import BatchPrintWorkTicketsForm from "./CaseMangement/batchprintworkticketsform";

import BatchPrintInvoices from "./Sales/batchPrintInvoices";
import Sales from "../reports/Sales/salesReport";
import SalesComparison from "../reports/Sales/salesComparison";
import AccountSales from "./Sales/AccountSales";
import CustomerSales from "./Sales/customerSales";
import ProductSales from "./Sales/productsSales";
import AlloySales from "./Sales/Alloysales";
import ProductComparison from "./Sales/productComparisonReport";
import UnitSalesAccountant from "./Sales/UnitSalesAccountant";
import UnitSalesProcedure from "./Sales/unitSalesProcedure";
import InvoicedItems from "./Sales/Invoiceditems";
import SalesReport from "./Sales/salesReport";
import ComponentSales from "./Sales/componentSales";
import ComponentSalesByAccount from "./Sales/componentSalesByAccount";

import PayPerTask from "./Costs/PayPerTask";
import PayPerTaskDetails from "./Costs/PayPerTaskDetails";
import InternalCaseRemake from "./Costs/InternalCaseRemakes";
import InternalCaseRemakeReason from "./Costs/InternalCaseRemakesReason";
import NextCasesByType from "./Costs/NextCasesByType";
import NextCasesByDes from "./Costs/NextCasesByTypeandDes";
import NextCasesTopAccounts from "./Costs/NextCasesTopAccounts";
import NextCasesCost from "./Costs/NextCasesCost";

import MoneyOwed from "../reports/Finances/Moneyowed";
import StatementsSummary from "../reports/Finances/StatementsSummary";
import BatchPrintOpenInvoices from "../reports/Finances/BatchPrintInvoice";
import RevenueOutlook from "../reports/Finances/RevenueOutlook";
import CreditLimits from "../reports/Finances/CreditLimits";
import RevnueCenter from "../reports/Finances/Revnuecenter";
import PriceLists from "../reports/Finances/PriceLists";

import ProcessPayments from "../reports/Payments/ProcessPayments";
import PaymentsbyAccounts from "../reports/Payments/PaymentsbyAccounts";
import PaymentsbyMethod from "../reports/Payments/PaymentsByMethod";

import Taxes from "../reports/Taxes/taxes";
import AccountsTaxableStatuses from "../reports/Taxes/AccountsTaxableStatuses";
import ProceduresTaxableStatuses from "../reports/Taxes/proceduresTaxableStatuses";

import Navvbar from "../../header/Navvbar";
import Header from "../../header/header";
import ReportParameters from "./CaseMangement/NewCases.js";

import "./reports.css";

const Reports = () => {
  const [openTabs, setOpenTabs] = useState([]);

  const [visibleTabs, setVisibleTabs] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);

  const adminTabs = [
    "Batch Print Work Tickets",
    "Batch Print Work Ticket Stickers",
    "Case Files",
    "Cases Shipped",
    "Case Turn Around Time",
    "Cases Cancelled",
    "Incomplete Tasks",
    "Complete Tasks",
    "Process Improvement",
    "Tagged Cases",
    "Case Tags",
    "Shipping",
    "Patient Appointment",
    "New Cases",
    "Batch Print Invoices",
    "Sales",
    "Sales Comparison",
    "Account Sales",
    "Customer Sales",
    "Product Sales",
    "Alloy Sales",
    "Product Comparison",
    "Unit Sales Analysis By Account",
    "Unit Sales Analysis By Procedure",
    "Invoiced Items",
    "Sales Reports",
    "Component Sales",
    "Component Sales By Account",
    "Pay Per Task",
    "Pay Per Task Details",
    "Internal Case Remakes",
    "Internal Case Remake Reason",
    "Next Cases By Type",
    "Next Cases By Description",
    "Next Cases By Top Accounts",
    "Next Cases Cost",
    "Money Owed",
    "Statements Summary",
    "Batch Print Open Invoices",
    "Revenue Outlook",
    "Credit Limits",
    "Revenue Center",
    "Price Lists",
    "Process Payments",
    "Payments by Accounts",
    "Payments by Method",
    "Taxes",
    "Accounts Taxable Statuses",
    "Procedures Taxable Statuses",
    "Lot and Serial Number Search",
  ];

  const enabledTabs = {
    "Batch Print Work Tickets": true,
    "Batch Print Work Ticket Stickers": true,
    "Case Files": true,

    "Cases Shipped": false,
    "Case Turn Around Time": false,

    "Cases Cancelled": true,

    "Incomplete Tasks": false,
    "Complete Tasks": false,
    "Process Improvement": false,
    "Tagged Cases": false,
    "Case Tags": false,
    "Shipping": false,
    "Patient Appointment": false,

    "New Cases": true,

    "Batch Print Invoices": true,

    Sales: true,

    "Sales Comparison": false,

    "Account Sales": true,

    "Customer Sales": false,
    "Product Sales": false,
    "Alloy Sales": false,
    "Product Comparison": false,
    "Unit Sales Analysis By Account": false,
    "Unit Sales Analysis By Procedure": false,

    "Invoiced Items": true,

    "Sales Reports": true,

    "Component Sales": false,
    "Component Sales By Account": false,

    "Pay Per Task": false,
    "Pay Per Task Details": false,
    "Internal Case Remakes": false,
    "Internal Case Remake Reason": false,
    "Next Cases By Type": false,
    "Next Cases By Description": false,
    "Next Cases By Top Accounts": false,
    "Next Cases Cost": false,

    "Money Owed": true,
    "Statements Summary": true,
    "Batch Print Open Invoices": true,
    "Revenue Outlook": true,
    "Credit Limits": true,
    "Revenue Center": true,
    "Price Lists": true,

    "Process Payments": false,
    "Payments by Accounts": false,
    "Payments by Method": false,

    Taxes: false,
    "Accounts Taxable Statuses": false,
    "Procedures Taxable Statuses": false,

    "Lot and Serial Number Search": false,
  };

  const displayNames = {
    "Revenue Center": "Revenue By Revenue Center",
  };

  const descriptions = {
    "Batch Print Work Tickets":
      "Print multiple work tickets for selected cases.",

    "Batch Print Work Ticket Stickers":
      "Print stickers for multiple work tickets.",

    "Case Files":
      "View and manage case files.",

    "Cases Shipped":
      "View cases that have been shipped.",

    "Case Turn Around Time":
      "View case turnaround time information.",

    "Cases Cancelled":
      "View cancelled cases.",

    "Incomplete Tasks":
      "View incomplete tasks.",

    "Complete Tasks":
      "View completed tasks.",

    "Process Improvement":
      "View process improvement information.",

    "Tagged Cases":
      "View cases grouped by tags.",

    "Case Tags":
      "Manage case tags.",

    Shipping:
      "View shipping information.",

    "Patient Appointment":
      "View patient appointment information.",

    "New Cases":
      "View new cases.",

    "Batch Print Invoices":
      "Print invoices for multiple cases.",

    Sales:
      "View sales information.",

    "Sales Comparison":
      "Compare sales information.",

    "Account Sales":
      "View sales by account.",

    "Customer Sales":
      "View customer sales.",

    "Product Sales":
      "View product sales.",

    "Alloy Sales":
      "View alloy sales.",

    "Product Comparison":
      "Compare product sales information.",

    "Unit Sales Analysis By Account":
      "View unit sales analysis by account.",

    "Unit Sales Analysis By Procedure":
      "View unit sales analysis by procedure.",

    "Invoiced Items":
      "Running list of Procedures with invoice and case numbers for a selected date range, designed for export",

    // ✅ FIX: pehle yahan "" (empty) tha — isliye Sales Reports tab ke neeche
    // description line nahi dikh rahi thi. Ab baaki tabs ki tarah description
    // show hogi. Aap apne hisaab se text badal sakte hain.
    "Sales Reports":
      "Running list of Procedures with invoice and case numbers for a selected date range, designed for export",

    "Component Sales":
      "View component sales.",

    "Component Sales By Account":
      "View component sales by account.",

    "Pay Per Task":
      "View pay per task information.",

    "Pay Per Task Details":
      "View pay per task details.",

    "Internal Case Remakes":
      "View internal case remakes.",

    "Internal Case Remake Reason":
      "View internal case remake reasons.",

    "Next Cases By Type":
      "View next cases by type.",

    "Next Cases By Description":
      "View next cases by description.",

    "Next Cases By Top Accounts":
      "View next cases by top accounts.",

    "Next Cases Cost":
      "View next cases cost.",

    "Money Owed":
      "Current account standings, how much do my accounts owe right now?",

    "Statements Summary":
      "How much was owed at the time of statement?",

    "Batch Print Open Invoices":
      "Batch print open invoices by account",

    "Revenue Outlook":
      "Current account standings, compared to a past statement period.",

    "Credit Limits":
      "Current account balances and respective credit limits.",

    "Revenue Center":
      "Revenue distribution by revenue center.",

    "Price Lists":
      "Price lists by procedure.",

    "Process Payments":
      "Process payments.",

    "Payments by Accounts":
      "View payments by accounts.",

    "Payments by Method":
      "View payments by payment method.",

    Taxes:
      "View tax information.",

    "Accounts Taxable Statuses":
      "View account taxable statuses.",

    "Procedures Taxable Statuses":
      "View procedure taxable statuses.",

    "Lot and Serial Number Search":
      "Search lot and serial numbers.",
  };

  const normalizeRole = (role) => {
    if (!role) return "";
    return String(role).toLowerCase().replace(/[\s\-_]+/g, "");
  };

  const getDefaultTabsForRole = (role) => {
    const roleLower = normalizeRole(role);

    const roleDefaults = {
      admin: adminTabs,

      manager: [
        "Batch Print Work Ticket Stickers",
        "Case Files",
        "Cases Shipped",
        "Case Turn Around Time",
        "Cases Cancelled",
        "Incomplete Tasks",
        "Complete Tasks",
        "Tagged Cases",
        "Shipping",
        "New Cases",
        "Batch Print Invoices",
        "Sales",
        "Account Sales",
        "Product Sales",
        "Invoiced Items",
        "Sales Reports",
        "Lot and Serial Number Search",
      ],

      sales: [
        "Batch Print Invoices",
        "Sales",
        "Account Sales",
        "Customer Sales",
        "Product Sales",
        "Invoiced Items",
        "Sales Reports",
      ],

      lab: [
        "Batch Print Work Ticket Stickers",
        "Case Files",
        "Cases Shipped",
        "Case Turn Around Time",
        "Incomplete Tasks",
        "Complete Tasks",
        "Shipping",
        "Lot and Serial Number Search",
      ],

      dentallab: [
        "Batch Print Work Tickets",
        "Batch Print Work Ticket Stickers",
        "Case Files",
        "Cases Shipped",
        "Case Turn Around Time",
        "Cases Cancelled",
        "Incomplete Tasks",
        "Complete Tasks",
        "Process Improvement",
        "Tagged Cases",
        "Case Tags",
        "Shipping",
        "Patient Appointment",
        "New Cases",
      ],

      accounting: [
        "Batch Print Invoices",
        "Money Owed",
        "Statements Summary",
        "Batch Print Open Invoices",
        "Revenue Outlook",
        "Credit Limits",
        "Process Payments",
        "Payments by Accounts",
        "Payments by Method",
        "Taxes",
      ],
    };

    return roleDefaults[roleLower] || [];
  };

  useEffect(() => {
    const fetchUserPermissions = async () => {
      try {
        const storedUserId = localStorage.getItem("userId");
        const userRole = localStorage.getItem("userRole") || "";
        const token = localStorage.getItem("token");

        setUserId(storedUserId);

        const normalizedRole = normalizeRole(userRole);

        if (
          normalizedRole === "admin" ||
          !userRole ||
          userRole.trim() === ""
        ) {
          setIsAdmin(true);
          setVisibleTabs(adminTabs);
          setLoading(false);
          return;
        }

        if (storedUserId && token) {
          try {
            const response = await fetch(
              `https://hms.backend.hiragroupcloud.com/api/user/${storedUserId}/pages`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (response.ok) {
              const data = await response.json();

              const pageNames = data
                .map((permission) => {
                  if (
                    permission.page &&
                    permission.page.name
                  ) {
                    return permission.page.name;
                  }

                  return permission.name || "";
                })
                .filter((name) => name !== "");

              if (pageNames.length > 0) {
                setVisibleTabs(pageNames);
              } else {
                console.warn(
                  "Backend returned no permissions for user, using role defaults for:",
                  userRole
                );
                setVisibleTabs(getDefaultTabsForRole(userRole));
              }
            } else {
              console.warn(
                "Failed to fetch permissions, using default for role:",
                userRole
              );

              setVisibleTabs(
                getDefaultTabsForRole(userRole)
              );
            }
          } catch (error) {
            console.error(
              "Error fetching permissions:",
              error
            );

            setVisibleTabs(
              getDefaultTabsForRole(userRole)
            );
          }
        } else {
          console.warn("No userId or token found, using role defaults");
          setVisibleTabs(getDefaultTabsForRole(userRole));
        }
      } catch (error) {
        console.error(
          "Error in fetchUserPermissions:",
          error
        );

        setVisibleTabs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUserPermissions();
  }, []);

  const shouldShowTab = (tabName) => {
    if (isAdmin) return true;

    return visibleTabs.includes(tabName);
  };

  const caseManagementReports = [
    "Batch Print Work Tickets",
    "Batch Print Work Ticket Stickers",
    "Case Files",
    "Cases Shipped",
    "Case Turn Around Time",
    "Cases Cancelled",
    "Incomplete Tasks",
    "Complete Tasks",
    "Process Improvement",
    "Tagged Cases",
    "Case Tags",
    "Shipping",
    "Patient Appointment",
    "New Cases",
  ];

  const salesReports = [
    "Batch Print Invoices",
    "Sales",
    "Sales Comparison",
    "Account Sales",
    "Customer Sales",
    "Product Sales",
    "Alloy Sales",
    "Product Comparison",
    "Unit Sales Analysis By Account",
    "Unit Sales Analysis By Procedure",
    "Invoiced Items",
    "Sales Reports",
    "Component Sales",
    "Component Sales By Account",
  ];

  const costsReports = [
    "Pay Per Task",
    "Pay Per Task Details",
    "Internal Case Remakes",
    "Internal Case Remake Reason",
    "Next Cases By Type",
    "Next Cases By Description",
    "Next Cases By Top Accounts",
    "Next Cases Cost",
  ];

  const financesReports = [
    "Money Owed",
    "Statements Summary",
    "Batch Print Open Invoices",
    "Revenue Outlook",
    "Credit Limits",
    "Revenue Center",
    "Price Lists",
  ];

  const paymentsReports = [
    "Process Payments",
    "Payments by Accounts",
    "Payments by Method",
  ];

  const taxesReports = [
    "Taxes",
    "Accounts Taxable Statuses",
    "Procedures Taxable Statuses",
  ];

  const identificationReports = [
    "Lot and Serial Number Search",
  ];

  const renderReportComponent = (reportName) => {
    switch (reportName) {
      case "Batch Print Work Tickets":
        return <TicketsForm />;

      case "Batch Print Work Ticket Stickers":
        return <BatchPrintWorkTicketsForm />;

      case "Case Files":
        return <Addfile />;

      case "Cases Shipped":
        return <CasesShipped />;

      case "Case Turn Around Time":
        return <TurnTime />;

      case "Cases Cancelled":
        return <CasesCancelled />;

      case "Incomplete Tasks":
        return <IncompleteTask />;

      case "Complete Tasks":
        return <CompleteTasks />;

      case "Process Improvement":
        return <ProcessImprovement />;

      case "Tagged Cases":
        return <TaggedCases />;

      case "Case Tags":
        return <CaseTags />;

      case "Shipping":
        return <Shipping />;

      case "Patient Appointment":
        return <PatientAppointment />;

      case "New Cases":
        return <ReportParameters />;

      case "Batch Print Invoices":
        return <BatchPrintInvoices />;

      case "Sales":
        return <Sales />;

      case "Sales Comparison":
        return <SalesComparison />;

      case "Account Sales":
        return <AccountSales />;

      case "Customer Sales":
        return <CustomerSales />;

      case "Product Sales":
        return <ProductSales />;

      case "Alloy Sales":
        return <AlloySales />;

      case "Product Comparison":
        return <ProductComparison />;

      case "Unit Sales Analysis By Account":
        return <UnitSalesAccountant />;

      case "Unit Sales Analysis By Procedure":
        return <UnitSalesProcedure />;

      case "Invoiced Items":
        return <InvoicedItems />;

      case "Sales Reports":
        return <SalesReport />;

      case "Component Sales":
        return <ComponentSales />;

      case "Component Sales By Account":
        return <ComponentSalesByAccount />;

      case "Pay Per Task":
        return <PayPerTask />;

      case "Pay Per Task Details":
        return <PayPerTaskDetails />;

      case "Internal Case Remakes":
        return <InternalCaseRemake />;

      case "Internal Case Remake Reason":
        return <InternalCaseRemakeReason />;

      case "Next Cases By Type":
        return <NextCasesByType />;

      case "Next Cases By Description":
        return <NextCasesByDes />;

      case "Next Cases By Top Accounts":
        return <NextCasesTopAccounts />;

      case "Next Cases Cost":
        return <NextCasesCost />;

      case "Money Owed":
        return <MoneyOwed />;

      case "Statements Summary":
        return <StatementsSummary />;

      case "Batch Print Open Invoices":
        return <BatchPrintOpenInvoices />;

      case "Revenue Outlook":
        return <RevenueOutlook />;

      case "Credit Limits":
        return <CreditLimits />;

      case "Revenue Center":
        return <RevnueCenter />;

      case "Price Lists":
        return <PriceLists />;

      case "Process Payments":
        return <ProcessPayments />;

      case "Payments by Accounts":
        return <PaymentsbyAccounts />;

      case "Payments by Method":
        return <PaymentsbyMethod />;

      case "Taxes":
        return <Taxes />;

      case "Accounts Taxable Statuses":
        return <AccountsTaxableStatuses />;

      case "Procedures Taxable Statuses":
        return <ProceduresTaxableStatuses />;

      case "Lot and Serial Number Search":
        return <LotSearch />;

      default:
        return null;
    }
  };

  const handleReportClick = (reportName) => {
    if (enabledTabs[reportName] !== true) {
      return;
    }

    setOpenTabs((previousTabs) => {
      if (previousTabs.includes(reportName)) {
        return previousTabs.filter(
          (name) => name !== reportName
        );
      }

      return [...previousTabs, reportName];
    });
  };

  const renderReportList = (reportNames) => {
    return reportNames.map((reportName) => {
      const isVisible = shouldShowTab(reportName);
      const isEnabled = enabledTabs[reportName] === true;
      const isActive = openTabs.includes(reportName);

      if (!isVisible) {
        return null;
      }

      return (
        <div
          key={reportName}
          className="reports-list-wrapper"
        >
          <div
            className={`report-list-item ${
              !isEnabled ? "disabled-tab" : ""
            } ${isActive ? "active-report-item" : ""}`}
            onClick={() => handleReportClick(reportName)}
            role={isEnabled ? "button" : undefined}
            tabIndex={isEnabled ? 0 : undefined}
            onKeyDown={(event) => {
              if (
                isEnabled &&
                (event.key === "Enter" ||
                  event.key === " ")
              ) {
                event.preventDefault();
                handleReportClick(reportName);
              }
            }}
          >
            <div className="report-list-title">
              {displayNames[reportName] || reportName}
            </div>

            <div className="report-list-desc">
              {descriptions[reportName] || ""}
            </div>
          </div>

          {isActive && isEnabled && (
            <div
              className="report-component-container"
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              {renderReportComponent(reportName)}
            </div>
          )}
        </div>
      );
    });
  };

  const renderCategorySection = (
    categoryName,
    reportNames
  ) => {
    return (
      <div className="reports-category-section">
        <div className="reports-category-content">
          <div className="reports-section">
            <div className="category-heading-wrapper">
              <h2 className="category-heading">
                {categoryName}
              </h2>
            </div>

            <div className="vertical-tabs-container">
              {renderReportList(reportNames)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <>
        <Header />
        <Navvbar />

        <div className="reports-page-container">
          <div className="reports-loading">
            Loading reports...
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <Navvbar />

      <div className="reports-page-container">
        <h1 className="title">Reports</h1>

        <div className="reports-main-layout">
          {renderCategorySection(
            "Case Management",
            caseManagementReports
          )}

          {renderCategorySection(
            "Sales",
            salesReports
          )}

          {renderCategorySection(
            "Costs",
            costsReports
          )}

          {renderCategorySection(
            "Finances",
            financesReports
          )}

          {renderCategorySection(
            "Payments",
            paymentsReports
          )}

          {renderCategorySection(
            "Taxes",
            taxesReports
          )}

          {renderCategorySection(
            "Identification and Traceability",
            identificationReports
          )}
        </div>
      </div>
    </>
  );
};

export default Reports;